import React, { Component } from "react";
import ReactDOM from "react-dom";
import Products from "../src/content_category_products/products";

class ContentCategoryProductsContainer extends Component {
  constructor() {
    super();
    this.state = { products: [] };
  }

  componentDidMount() {
    const path = `${window.location.pathname.slice(0, -1)}.json`;

    fetch(path)
      .then((response) => response.json())
      .then((data) => {
        this.setState({ products: data.products });
      });
  }

  render() {
    const { products } = this.state;

    return <Products products={products} />;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".advisor-category-products");

  Array.from(elements).forEach((element) =>
    ReactDOM.render(<ContentCategoryProductsContainer />, element)
  );
});
